import api from "./api";

const examService = {
  getExams: (params) => api.get("/exams", { params }),

  getExamById: (id) => api.get(`/exams/${id}`),

  createExam: (examData) => api.post("/exams", examData),

  updateExam: (id, examData) => api.put(`/exams/${id}`, examData),

  deleteExam: (id) => api.delete(`/exams/${id}`),

  getExamResults: (params) => api.get("/exams/results", { params }),

  getStudentResults: (studentId, params) =>
    api.get(`/exams/results/student/${studentId}`, { params }),

  submitScores: (examId, scores) =>
    api.post(`/exams/${examId}/scores`, { scores }),

  updateStudentScore: (examId, studentId, data) =>
    api.put(`/exams/${examId}/scores/${studentId}`, data),

  downloadExamReport: (examId) =>
    api.get(`/exams/${examId}/report/download`, {
      responseType: "blob",
    }),

  downloadResultCard: (studentId, params) =>
    api.get(`/exams/result-card/${studentId}`, {
      params,
      responseType: "blob",
    }),

  getExamStatistics: (examId) => api.get(`/exams/${examId}/statistics`),

  publishResults: (examId) => api.post(`/exams/${examId}/publish`),

  unpublishResults: (examId) => api.post(`/exams/${examId}/unpublish`),
};

export default examService;
